// extracted by mini-css-extract-plugin
module.exports = {"button":"Signin_button__250bX","prefix-icon":"Signin_prefix-icon__TBXzo"};